import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    locales: [
        {
            code: "en",
            name: "English",
        },
        {
            code: "de",
            name: "Deutsch",
        },
        // {
        //     code: "fr",
        //     name: "Français",
        // },
        // {
        //     code: "it",
        //     name: "Italiano",
        // },
        // {
        //     code: "es",
        //     name: "Español",
        // },
    ],
    defaultLanguage: "de",
};

export const localesSlice = createSlice({
    name: "availableLanguages",
    initialState,
    reducers: {
        setLocales: (state, action) => {
            state.locales = action.payload;
        },
        setDefaultLanguage: (state, action) => {
            state.defaultLanguage = action.payload;
        },
    },
});

export const { setLocales } = localesSlice.actions;
